import {Injectable} from "@angular/core";
import {Widget} from "@widgets/dashboard";
import {EditingWidget} from "@widgets/widget-constructor";
import {WidgetElement} from "@entities/widget-element";

@Injectable({providedIn: "root"})
export class DashboardMapperService {
    mapWidgetToEditingWidget(widget: Widget): EditingWidget {
        return {
            id: widget.id,
            cols: widget.data.grid.cols,
            rows: widget.data.grid.rows,
            name: widget.data.name,
            elements: this.mapElementsToEditingWidgetElements(widget.data.elements)
        };
    }

    mapEditingWidgetToNewWidget(widget: EditingWidget, id: number): Widget {
        return {
            id: String(id),
            x: 1000,
            y: 1000,
            w: 3,
            h: 3,
            data: {
                name: widget.name,
                grid: {
                    cols: widget.cols,
                    rows: widget.rows,
                },
                elements: this.mapEditingWidgetElementsToElements(widget.elements),
            }
        };
    }

    mapEditingWidgetToWidget(widget: EditingWidget): Partial<Widget> {
        return {
            id: widget.id,
            data: {
                name: widget.name,
                grid: {
                    cols: widget.cols,
                    rows: widget.rows,
                },
                elements: this.mapEditingWidgetElementsToElements(widget.elements),
            }
        };
    }

    mapElementsToEditingWidgetElements(elements: WidgetElement[]): Record<string, WidgetElement> {
        return elements.reduce((acc, element) => {
            acc[element.id] = element;
            return acc;
        }, {} as Record<string, WidgetElement>);
    }

    mapEditingWidgetElementsToElements(elements: Record<string, WidgetElement>): WidgetElement[] {
        return Object.values(elements);
    }

    createNewEditingWidget() {
        return {
            cols: 6,
            rows: 2,
            name: "Новый виджет",
            elements: {},
        };
    }
}
